export function startComparisonSplitEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.spark-canvas');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const resize = () => {
    const divider = imgPanelEl.querySelector('.split-divider');
    const w = divider ? divider.offsetWidth : 120;
    const h = imgPanelEl.offsetHeight || 600;
    canvas.width = Math.max(1, w);
    canvas.height = Math.max(1, h);
  };

  resize();

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  const sparks = [];

  const intervalId = setInterval(() => {
    if (!canvas.isConnected) return;

    const w = canvas.width;
    const h = canvas.height;

    if (Math.random() > 0.7) {
      sparks.push({
        y: Math.random() * h,
        life: 1.0
      });
    }

    ctx.clearRect(0, 0, w, h);

    for (let i = sparks.length - 1; i >= 0; i--) {
      const s = sparks[i];
      s.life -= 0.08;

      if (s.life <= 0) {
        sparks.splice(i, 1);
        continue;
      }

      ctx.strokeStyle = `rgba(255, 255, 0, ${s.life})`;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(w * 0.25, s.y);
      ctx.lineTo(w * 0.75, s.y + (Math.random() - 0.5) * 20);
      ctx.stroke();
    }
  }, 100);

  return () => {
    clearInterval(intervalId);
    if (observer) observer.disconnect();
  };
}
